// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { LyonEmptyStateImage } from './LyonEmptyStateImage';
import { LyonEmptyStateInfo } from './LyonEmptyStateInfo';

// ANCHOR Styles
import { BLOCK, BLOCK_WITH_IMAGE, BLOCK_WITH_IMAGE_BORDERS } from './styles';

interface IProps {
  label?: string;
  marginTop?: string;
  hasImage?: boolean;
  hasBorders?: boolean;
  imgAlt?: string;
  type?: 'default' | 'event' | 'thumbnail' | 'course';
  actionButton?: React.ReactNode;
}

export function LyonEmptyState({
  label,
  imgAlt,
  hasBorders = true,
  hasImage,
  marginTop = '0',
  type = 'default',
  actionButton,
}: IProps) {
  const blockWithImage = hasBorders
    ? BLOCK_WITH_IMAGE_BORDERS
    : BLOCK_WITH_IMAGE;

  const withImage = hasImage
    || imgAlt
    || type === 'course'
    || type === 'event'
    || type === 'thumbnail';

  return (
    <Block
      marginTop={marginTop}
      overrides={!withImage ? BLOCK : blockWithImage}
    >
      {withImage && <LyonEmptyStateImage type={type} imgAlt={imgAlt} />}
      <LyonEmptyStateInfo type={type} label={label} actionButton={actionButton} />
    </Block>
  );
}
